import About from "./pages/About.js";
import Login from "./pages/Login.js";
import Register from "./pages/Register.js";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import UserProfile from "./pages/userProfile.js";
import BarCouncil from "./pages/BarCouncil/BarCouncil.js";
import HighCourtSR from "./pages/HighCourtSR.js";
import LowerCourtSR from "./pages/LowerCourtSR.js";
import Memories from "./pages/Memories.js";
import EventPage from "./pages/EventPage.js";
import StudentOpportunity from "./pages/StudentOpportunity.js";
import Review from "./components/Review/Review.js";
import ContactUs from "./components/ContactUs/ContactUs.js";
import Attendence from "./components/Attendance/Attendence.js";
// import PaymentDetails from "./components/Common/PaymentDetails/PaymentDetails.js";
import PrivateRoute from "./Routes/PrivateRoute.js";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import Homepage from "./pages/HomePage.js";

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/lower-court-sr" element={<LowerCourtSR />}></Route>
          <Route path="/high-court-sr" element={<HighCourtSR />}></Route>
          <Route path="/memories" element={<Memories />}></Route>
          <Route path="/memories/:eventId" element={<EventPage />}></Route>
          <Route path="/register" element={<Register />}></Route>
          <Route path="/association" element={<StudentOpportunity />}></Route>
          <Route path="/bar-council" element={<BarCouncil />}></Route>
          <Route
            path="/userProfile"
            element={
              <PrivateRoute>
                <UserProfile />
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/review"
            element={
              <PrivateRoute>
                <Review />
              </PrivateRoute>
            }
          ></Route>
          {/* <Route path="/payment" element={<PrivateRoute><PaymentDetails /></PrivateRoute>}></Route> */}
          <Route path="/contacts" element={<ContactUs />}></Route>
          <Route path="/attendance" element={<Attendence />}></Route>
          <Route path="*" element="<h1>404 Not Found</h1>"></Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
